import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" />, 'ArrowRightAlt');
